<template>
  <v-text-field
    v-model="text"
    outlined
    dense
    single-line
    placeholder="Betreff"
    @change="$emit('update', text)"
  >
    <slot
      slot="append-outer"
      name="append-outer"
    />
  </v-text-field>
</template>

<script>
  export default {
    name: 'BaseTextField',

    props: {
      initialvalue: String,
    },
    data () {
      return {
        text: this.initialvalue,
      }
    },
  }
</script>

<style lang="sass">
  //
</style>
